import { gql } from './apollo';

export const GET_GC_INVENTORIES_FOR_PROPERTY = gql`
    query ($property_id: MultiTypeInput!, $offset: Int = 0, $limit: Int = 10) {
        table(
            name: "gc_inventory"
            join: [{ table: "propertyuser__c", fk: "id", joinFk: "counted_by" }]
            filter: [{ left: "property__c_id", right: $property_id, expression: "=" }]
            contain: [
                {
                    table: "propertyuser__c"
                    alias: "counted_by_propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "counted_by"
                    limit: 1
                }
                {
                    table: "propertyuser__c"
                    alias: "approved_by_propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "approved_by"
                    limit: 1
                }
            ]
            orderBy: "date"
            orderByDirection: DESC
            offset: $offset
            limit: $limit
        )
    }
`;

export const GET_GC_INVENTORY_BY_ID = gql`
    query ($id: MultiTypeInput!) {
        table(
            name: "gc_inventory"
            filter: [{ left: "id", right: $id, expression: "=" }]
            join: [
                { table: "propertyuser__c", fk: "id", joinFk: "counted_by" }
                { table: "sku", fk: "id", joinFk: "sku" }
                { table: "property__c", fk: "id", joinFk: "property__c_id" }
            ]
            contain: [
                {
                    table: "propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "counted_by"
                    limit: 1
                }
                {
                    table: "sku"
                    columns: ["description", "detailed_form"]
                    fk: "id"
                    joinFk: "sku"
                    limit: 1
                }
                {
                    table: "property__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "property__c_id"
                    limit: 1
                }
            ]
            limit: 1
        )
    }
`;

export const GET_GC_INVENTORIES_BY_SKUS_FOR_PROPERTY = gql`
    query ($property_id: MultiTypeInput!, $sku_ids: MultiTypeInput) {
        table(
            name: "gc_inventory"
            filter: [
                { left: "property__c_id", right: $property_id, expression: "=" }
                { left: "sku", right: $sku_ids, expression: "IN" }
            ]
            orderBy: "date"
            orderByDirection: DESC
            limit: 1000
        )
    }
`;

export const CREATE_GC_INVENTORY = gql`
    mutation (
        $sku: MultiTypeInput
        $on_hand: MultiTypeInput
        $activated: MultiTypeInput
        $destroyed: MultiTypeInput
        $lost: MultiTypeInput
        $received: MultiTypeInput
        $transferred: MultiTypeInput
        $reason: MultiTypeInput
        $counted_by: MultiTypeInput
        $property__c_id: MultiTypeInput
        $date: MultiTypeInput
        $comment: MultiTypeInput
    ) {
        createRow(
            table: "gc_inventory"
            values: [
                { property: "sku", value: $sku }
                { property: "on_hand", value: $on_hand }
                { property: "activated", value: $activated }
                { property: "destroyed", value: $destroyed }
                { property: "lost", value: $lost }
                { property: "received", value: $received }
                { property: "transferred", value: $transferred }
                { property: "reason", value: $reason }
                { property: "counted_by", value: $counted_by }
                { property: "property__c_id", value: $property__c_id }
                { property: "date", value: $date }
                { property: "comment", value: $comment }
            ]
        )
    }
`;

export const UPDATE_GC_INVENTORY = gql`
    mutation (
        $id: String!
        $on_hand: MultiTypeInput
        $activated: MultiTypeInput
        $destroyed: MultiTypeInput
        $lost: MultiTypeInput
        $received: MultiTypeInput
        $transferred: MultiTypeInput
        $reason: MultiTypeInput
        $counted_by: MultiTypeInput
        $date: MultiTypeInput
        $comment: MultiTypeInput
    ) {
        updateRow(
            table: "gc_inventory"
            id: $id
            values: [
                { property: "on_hand", value: $on_hand }
                { property: "activated", value: $activated }
                { property: "destroyed", value: $destroyed }
                { property: "lost", value: $lost }
                { property: "received", value: $received }
                { property: "transferred", value: $transferred }
                { property: "reason", value: $reason }
                { property: "counted_by", value: $counted_by }
                { property: "date", value: $date }
                { property: "comment", value: $comment }
            ]
        )
    }
`;

export const DELETE_GC_INVENTORY = gql`
    mutation ($id: String!) {
        deleteRow(table: "gc_inventory", id: $id)
    }
`;

export const APPROVE_GC_INVENTORY = gql`
    mutation ($id: String!, $approved_by: MultiTypeInput!) {
        updateRow(
            table: "gc_inventory"
            id: $id
            values: [{ property: "approved_by", value: $approved_by }]
        )
    }
`;
